import { render } from "./vs-result.vue?vue&type=template&id=40150cdb&scoped=true&ts=true"
import script from "./vs-result.vue?vue&type=script&lang=ts"
export * from "./vs-result.vue?vue&type=script&lang=ts"

import "./vs-result.vue?vue&type=style&index=0&id=40150cdb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40150cdb"]])

export default __exports__